import { render, staticRenderFns } from "./PageMakePayment.vue?vue&type=template&id=ca568cee&scoped=true&"
import script from "./PageMakePayment.vue?vue&type=script&lang=js&"
export * from "./PageMakePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca568cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca568cee')) {
      api.createRecord('ca568cee', component.options)
    } else {
      api.reload('ca568cee', component.options)
    }
    module.hot.accept("./PageMakePayment.vue?vue&type=template&id=ca568cee&scoped=true&", function () {
      api.rerender('ca568cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/billpay/PageMakePayment.vue"
export default component.exports